import { S3_BASE_URL } from 'constants/static';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isLoginFormOpenState, isMenuOpenState } from 'store/atoms';
import styled from 'styled-components';
import { useTranslation } from 'i18n';

const HeaderContainer = styled.header`
  display: flex;
  background-color: #fff;
  height: 58px;
  padding: 14px 24px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaebef;
  z-index: 1001;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 24px;
`;

const BackButton = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CenterSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #0f0f0f;
  text-align: center;
  margin: 0;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 24px;
`;

const MenuButton = styled.button<{ $isOpen: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1000;
`;

interface BackButtonHeaderProps {
  title: string;
}

export function BackButtonHeader({ title }: BackButtonHeaderProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMenuOpen = useRecoilValue(isMenuOpenState);
  const isLoginFormOpen = useRecoilValue(isLoginFormOpenState);
  const setIsMenuOpen = useSetRecoilState(isMenuOpenState);
  const setIsLoginFormOpen = useSetRecoilState(isLoginFormOpenState);

  const handleBack = () => {
    navigate(-1);
  };

  const handleMenuClick = () => {
    if (isLoginFormOpen) {
      setIsLoginFormOpen(false);
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  const iconSrc = () => {
    if (isMenuOpen || isLoginFormOpen) {
      return `${S3_BASE_URL}/close_icon.svg`;
    }
    return `${S3_BASE_URL}/menu_icon.svg`;
  };

  return (
    <HeaderContainer>
      <LeftSection>
        <BackButton onClick={handleBack} aria-label={t('common.back')}>
          <img src={`${S3_BASE_URL}/back_button_icon.svg`} width={10} height={17} alt="back_icon" />
        </BackButton>
      </LeftSection>
      <CenterSection>
        <Title>{title}</Title>
      </CenterSection>
      <RightSection>
        <MenuButton $isOpen={isMenuOpen} onClick={handleMenuClick}>
          <img src={iconSrc()} alt="menu_icon" width={24} height={24} />
        </MenuButton>
      </RightSection>
    </HeaderContainer>
  );
}
